import { omit } from "lodash";
import { selectServiceByProviderAndType } from "./projectWizardSelectors.js";
import { hydrateCopyObjectWithValue } from "../locale/copyUtils.js";

import { ALL_RESOURCE_KEYS } from "../../../constants/entity.js";
import { CONFIG } from "./projectWizardConfigs/config.js";
import { padNumber } from "../../../utils/numberUtils.js";

function expandResourceData(item, values, schedules, state) {
  const { region, zone, provider } = values;

  let service = item.service;
  if (!service) {
    service = selectServiceByProviderAndType(state, {
      provider,
      resourceType: item["@type"]
    })["@id"];
  }

  // -- START - nasty WIRE GUARD HACK -- //

  // this will cause a controlled component error to be thrown but until we can work in field dependencies
  // there's not much we can do about it without a larger restructure

  if (
    item.image === "/images/CbJ2JZr7-vRiH-je6x-rZcn-f0gUnialAGyg" || // AWS
    item.image === "/images/e4b95dbe-acdd-4fd8-894c-79d9f439538f" || // AWS 2
    item.image === "/images/7721a7ac-c82a-4293-893a-bc5639e8b231" || // AWS 3
    item.image === "/images/28afc343-94e9-45ae-93a8-bf41812df813" || // AWS - 18.2.7
    item.image === "/images/40c9d930-6af0-45c3-815d-027f1d258dea" || // AWS - Rocky 8.9
    item.image === "/images/370947af-9765-4fcb-93e2-5b273ecfc01b" || // AWS
    item.image === "/images/797330f3-32a5-435f-ab8f-4d20769eaaae" || // GCP - Centos
    item.image === "/images/1467bcb0-e07c-4f65-98f9-e6717b806b17" || // GCP - Rocky
    item.image === "/images/d46cb380-8132-47d6-8fd3-22c552787484" || // GCP 3 - Rocky 8.8
    item.image === "/images/4fcafdaa-2d43-4de1-ad9b-76ecc57ca84f" || // GCP 3 - 18.2.7
    item.image === "/images/392617f9-9bf8-477e-a88f-7578b3d4effd" || // GCP - Rocky 8.9
    item.image === "/images/2361024d-5d44-438e-a012-901a49829305" || // GCP
    item.image === "/images/d8e495ad-67d2-467c-8b8a-443f98d63157" || // Azure - Rocky 8.8
    item.image === "/images/9035b74a-c577-4c75-baf0-a0b639a1d03f" // Azure
  ) {
    delete item.sitePublicIP;
    delete item.siteSubnet;
  }

  // -- END - nasty WIRE GUARD HACK -- //

  return {
    ...item,
    service,
    region: region ? region : item.region,
    zone: zone ? zone : item.zone,
    schedules
  };
}

export function buildProjectCreationData(state, values, atId, schedules) {
  const {
    projectId,
    name,
    description,
    requiresUserVerification,
    cidrClassPrefix,
    cidrClassPrefixPrime,
    cidrClassPrefixSub,
    sshKeys
  } = values;

  let data = {
    name,
    description,
    cidrClassPrefix,
    sshKeys
  };

  if (cidrClassPrefixPrime && cidrClassPrefixSub) {
    data.cidrClassPrefix = `${cidrClassPrefixPrime}.${cidrClassPrefixSub}`;
  }

  if (requiresUserVerification === 1 || requiresUserVerification === 0) {
    data.requiresUserVerification = requiresUserVerification ? true : false;
  }

  if (atId || projectId) {
    data["@id"] = atId || projectId;
    data.projectId = atId || projectId;
  }

  // safe to use ALL_ here rather than USER_ as any empty types will be ignored
  ALL_RESOURCE_KEYS.forEach(type => {
    const resources = values[type];

    if (resources && resources.length > 0) {
      data[type] = resources.flatMap(resource => {
        if (resource.number && resource.namingScheme) {
          const instances = [];
          const startAt = resource.startAt ?? 1;

          for (let i = 0; i < resource.number; i++) {
            const sequence = startAt + i;

            const sequencer = resource.useZeroPadding
              ? padNumber(sequence, 4)
              : sequence;

            const newResource = {
              ...omit(resource, "name", "number", "namingScheme"),
              name: hydrateCopyObjectWithValue(resource.namingScheme, sequencer)
            };

            instances.push(
              expandResourceData(newResource, values, schedules, state)
            );
          }

          return instances;
        }

        return expandResourceData(resource, values, schedules, state);
      });
    }
  });

  return data;
}

export function getConfigByConfigId(configId) {
  let parsedConfigId = null;

  if (configId && typeof configId === "string") {
    parsedConfigId = configId.toUpperCase().split("-").join("_");
  }

  const config = CONFIG[parsedConfigId];

  if (!config) {
    console.warn(
      "projectWizardUtils: getConfigByConfigId could not parse and retrive the passed configId so has defaulted to the BASIC config Object"
    );
  }

  return config || CONFIG["DEFAULT"];
}

const projectWizardUtils = {
  buildProjectCreationData,
  getConfigByConfigId
};

export default projectWizardUtils;
